import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-snack-bar-install',
  imports: [MatButtonModule],
  templateUrl: './snack-bar-install.component.html',
  styleUrl: './snack-bar-install.component.scss'
})
export class SnackBarInstallComponent {
  data = inject(MAT_SNACK_BAR_DATA);
  snackBarRef = inject(MatSnackBarRef<SnackBarInstallComponent>);

  install(): void {
    this.snackBarRef.dismiss();
    this.data.onInstall();
  }
}
